import { render, staticRenderFns } from "./RequirementForm.vue?vue&type=template&id=c85551e0&"
import script from "./RequirementForm.vue?vue&type=script&lang=js&"
export * from "./RequirementForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports